import { BATCH_STATUS_VALUE, PROVIDER_BATCH_STATUS_VALUE } from "./system-default-data-constant";

export enum BatchStatus {
  Creating = 1,
  Posted = 2,
  Reviewed = 3,
  Reviewing = 4,
  Settled = 5,
  Settling = 6,
  Submitted = 7,
}

export const BatchStatusLabel: { [key in BatchStatus]: string } = {
  [BatchStatus.Creating]: 'CLAIM.BATCH.STATUS_TYPE.CREATING',
  [BatchStatus.Posted]: 'CLAIM.BATCH.STATUS_TYPE.POSTED',
  [BatchStatus.Reviewed]: 'CLAIM.BATCH.STATUS_TYPE.REVIEWED',
  [BatchStatus.Reviewing]: 'CLAIM.BATCH.STATUS_TYPE.REVIEWING',
  [BatchStatus.Settled]: 'CLAIM.BATCH.STATUS_TYPE.SETTLED',
  [BatchStatus.Settling]: 'CLAIM.BATCH.STATUS_TYPE.SETTLING',
  [BatchStatus.Submitted]: 'CLAIM.BATCH.STATUS_TYPE.SUBMITTED',
};

export const BatchStatusValue: { [key in BatchStatus]: string } = {
  [BatchStatus.Creating]: BATCH_STATUS_VALUE.CREATING,
  [BatchStatus.Posted]: BATCH_STATUS_VALUE.POSTED,
  [BatchStatus.Reviewed]: BATCH_STATUS_VALUE.REVIEWED,
  [BatchStatus.Reviewing]: BATCH_STATUS_VALUE.REVIEWING,
  [BatchStatus.Settled]: BATCH_STATUS_VALUE.SETTLED,
  [BatchStatus.Settling]: BATCH_STATUS_VALUE.SETTLING,
  [BatchStatus.Submitted]: BATCH_STATUS_VALUE.SUBMITTED,
};

export enum ProviderBatchStatus {
  Creating = 1,
  Submitted = 2,
  ReadySubmisison = 3
}

export const ProviderBatchStatusValue: { [key in ProviderBatchStatus]: string } = {
  [ProviderBatchStatus.Creating]: PROVIDER_BATCH_STATUS_VALUE.CREATING,
  [ProviderBatchStatus.Submitted]: PROVIDER_BATCH_STATUS_VALUE.SUBMITTED,
  [ProviderBatchStatus.ReadySubmisison]: PROVIDER_BATCH_STATUS_VALUE.READY_SUBMISSION
};
